@if (formControl()) {
<div class="number form-group">
    <mat-form-field class="form-field">
        <input type="number" matInput [placeholder]="$safeNavigationMigration(meta()?.name)" [step]="$safeNavigationMigration(meta()?.step)" [formControl]="formControl()!"
            [readonly]="readonly() || meta()?.readonly">
        @if (meta()?.info) {
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('min')) {
        <mat-error>
            {{meta()?.name}} must be greater than or equal to {{meta()?.min}}
        </mat-error>
        }
        @if (formControl()?.hasError('max') ) {
        <mat-error>
            {{meta()?.name}} must be less than {{meta()?.max}}
        </mat-error>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta()?.name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('range')) {
        <mat-error>
            Invalid minimum and maximum range
        </mat-error>
        }
    </mat-form-field>
</div>
}
